import { Component } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import 'rxjs/add/operator/filter';
import { NavigationStart, Event as NavigationEvent } from '@angular/router';

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: `./breadcrumb.component.html`
})
export class BreadcrumbsComponent {
  breadcrumbs: Array<Object>;
  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.router.events.forEach((event: NavigationEvent) => {
      if (event instanceof NavigationEnd) {
   
        console.log(event.url)
    }
  });
    this.router.events.filter(event => event instanceof NavigationEnd).subscribe((event) => {
      this.breadcrumbs = [];
      let currentRoute = this.route.root,
      
      url = '';
      do {
        const childrenRoutes = currentRoute.children;
        currentRoute = null;
        childrenRoutes.forEach(route => {
          if (route.outlet === 'primary') {
            const routeSnapshot = route.snapshot;
            url += '/' + routeSnapshot.url.map(segment => segment.path).join('/');
            this.breadcrumbs.push({
              label: route.snapshot.data,
              url:   url.replace("//","/")
            });
            
            currentRoute = route;
          }
        });
      } while (currentRoute);
    });
  }
}
